import classes from "./BoxEntity.module.css";

const BoxEntity = ({ className, icon, content, styleValue, value, date }) => {
  return (
    <div
      className={[classes.boxEntity, classes.gridContainer, className].join(
        " "
      )}
    >
      <div className={classes.boxEntity_icon}>
        {icon && icon !== "-" && icon.includes("im") ? (
          <i className={icon}></i>
        ) : (
          <img src={icon} alt="icon" width="32px" />
        )}
      </div>
      <div className={classes.boxEntity_content}>
        <h4>{content}</h4>
        <span
          style={{
            fontSize: "9px",
          }}
        >
          {date}
        </span>
      </div>
      <div className={classes.boxEntity_value} style={styleValue}>
        {value}
      </div>
    </div>
  );
};
export default BoxEntity;
